import React, { useEffect, useState } from "react";
import {
  Document,
  Page,
  View,
  Text,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import BrandImg from "../../../../Assets/logo.png";
import moment from "moment";
export default function PdfFile({
  month,
  hourlyRate,
  dueDate,
  comment,
  hoursInMonth,
  jobDetails,
  weeksOfMonth,
  invoiceId,
  invoiceNo,
  userDetails,
}) {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <Text style={styles.headerText}>Invoice</Text>
        </View>
        <View style={styles.mainSection}>
          <View style={styles.sectionHeaderData}>
            <View>
              <View style={styles.companyTab}>
                {userDetails?.profilePhoto && <Image
                  style={styles.companyLogo}
                  alt="company"
                  src={userDetails?.profilePhoto}
                />}
                <Text>{`${userDetails?.company}`}</Text>
              </View>
              {userDetails?.address && (
                <Text>
                  {userDetails.address}
                  {","}
                </Text>
              )}
              {userDetails?.city && (
                <Text>
                  {userDetails.city}
                  {","}
                </Text>
              )}
              {userDetails?.state && (
                <Text>
                  {userDetails.state} {userDetails?.zip}
                  {","}
                </Text>
              )}
              {userDetails?.country && <Text>{userDetails.country}</Text>}
            </View>
            <View>
              {invoiceId && <Text>Invoice No: {invoiceNo}</Text>}
              <Text>Invoice Date: {moment.utc().format("DD-MM-YYYY")} </Text>
              {dueDate && <Text>Due Date: {dueDate} </Text>}
              <Text>Amount: ${hourlyRate * hoursInMonth} </Text>
            </View>
          </View>
          <View style={styles.section}>
            <View style={styles.invoiceDataFlex}>
              <View>
                <Text style={styles.invoiceDataTitle}>Billed To</Text>
                {jobDetails.owner && (
                  <>
                    <Text>{`${jobDetails.owner?.company}`}</Text>
                    <Text>{jobDetails.owner?.email}</Text>
                  </>
                )}
              </View>
              <View>
                <Text style={styles.invoiceDataTitle}>Period</Text>
                <Text>{moment(month, "MM-YYYY").format("MMMM, YYYY")}</Text>
              </View>
              <View>
                <Text style={styles.invoiceDataTitle}>Hourly Rate</Text>
                <Text>{hourlyRate}$</Text>
              </View>
            </View>
            <View style={styles.invoiceDataFlex}>
              <View>
                <Text style={styles.invoiceDataTitle}>Consultant:</Text>
                {jobDetails.consultant && (
                  <Text>{`${jobDetails.consultant?.firstName} ${jobDetails.consultant?.lastName}`}</Text>
                )}
              </View>
              <View>
                <Text style={styles.invoiceDataTitle}>Job Title</Text>
                <Text>{jobDetails.name}</Text>
              </View>
              <View>
                <Text>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </Text>
              </View>
            </View>
          </View>
          <View style={styles.tableContainer}>
            <InvoiceTableHeader />
            {weeksOfMonth.map((week) => (
              <InvoiceTableRow week={week} hourlyRate={hourlyRate} />
            ))}
            <InvoiceTableFooter
              hourlyRate={hourlyRate}
              hoursInMonth={hoursInMonth}
            />
          </View>
          {comment && <Comment comment={comment} />}
        </View>
        <Footer />
      </Page>
    </Document>
  );
}
const InvoiceTableHeader = () => (
  <View style={tableHeader.container}>
    <Text style={tableHeader.week}>Week</Text>
    <Text style={tableHeader.approved}>Approved</Text>
    <Text style={tableHeader.hours}>Hours</Text>
    <Text style={tableHeader.amount}>Amount</Text>
  </View>
);
const InvoiceTableRow = ({ week, hourlyRate }) => {
  const hours = (parseInt(week.hours) + parseInt(week.minutes) / 60).toFixed(3);
  return (
    <View style={tableRow.row}>
      <Text style={tableRow.week}>
        {moment.utc(week.start).format("DD-MMM") +
          " to " +
          moment.utc(week.end).format("DD-MMM")}
      </Text>
      {week.approvedBy ? (
        <Text style={tableRow.approved}>
          {/* {`${week.approvedBy?.firstName} ${week.approvedBy?.lastName}`}
          {`(${week.approvedBy?.email}) `} */}
          <Text>{moment(week.createdAt).format("DD-MM-YYYY HH:MM")}</Text>
        </Text>
      ) : (
        <Text style={tableRow.approved}>{week.approvedByExternal}</Text>
      )}
      <Text style={tableRow.hour}>{Math.floor(hours)}</Text>
      <Text style={tableRow.amount}>{hours * hourlyRate}</Text>
    </View>
  );
};
const InvoiceTableFooter = ({ hoursInMonth, hourlyRate }) => {
  return (
    <View style={tableFooter.row}>
      <Text style={tableFooter.description}>TOTAL</Text>
      <Text style={tableFooter.total}>{hoursInMonth * hourlyRate}</Text>
    </View>
  );
};
const Footer = () => (
  <View style={footerStyle.base}>
    <Image src={BrandImg} style={footerStyle.logoImg} />
  </View>
);
const Comment = ({ comment }) => (
  <View style={commentStyle.base}>
    <Text style={commentStyle.title}>Comment</Text>
    <View style={commentStyle.box}>
      <Text>{comment}</Text>
    </View>
  </View>
);
const borderColor = "#BDBDBD";
const styles = StyleSheet.create({
  page: {
    fontSize: "13px",
    flexDirection: "column",
    backgroundColor: "white",
  },
  header: {
    backgroundColor: "#139588",
    padding: "14px 0px",
  },
  headerText: {
    textAlign: "center",
    color: "white",
    fontSize: "20px",
    fontWeight: "bold",
  },
  mainSection: {
    padding: "24px",
  },
  section: {
    marginTop: "24px",
  },
  sectionHeaderData: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  invoiceDataFlex: {
    marginTop: "24px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  invoiceDataTitle: {
    color: "#139588",
    fontSize: "14px",
    marginBottom: "5px",
  },
  tableContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 24,
    borderWidth: 1,
    borderColor: "#BDBDBD",
  },
  companyLogo: {
    height: "20px",
    weight: "20px",
    marginRight: "5px",
    borderRadius: "50%",
  },
  companyTab: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 10,
  },
});

const tableHeader = StyleSheet.create({
  container: {
    flexDirection: "row",
    borderBottomColor: "#BDBDBD",
    borderBottomWidth: 1,
    alignItems: "center",
    height: 40,
    textAlign: "center",
    fontStyle: "bold",
    flexGrow: 1,
  },
  week: {
    width: "30%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
  },
  approved: {
    width: "30%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
  },
  hours: {
    width: "20%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
  },
  amount: {
    width: "20%",
  },
});
const tableRow = StyleSheet.create({
  row: {
    flexDirection: "row",
    borderBottomColor: "#BDBDBD",
    borderBottomWidth: 1,
    alignItems: "center",
    minHeight: 40,
    fontStyle: "bold",
  },
  week: {
    width: "30%",
    textAlign: "center",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingLeft: 8,
  },
  approved: {
    fontSize: 10,
    width: "30%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "center",
    paddingRight: 8,
  },
  hour: {
    width: "20%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "center",
    paddingRight: 8,
  },
  amount: {
    width: "20%",
    textAlign: "right",
    paddingRight: 8,
  },
});
const tableFooter = StyleSheet.create({
  row: {
    flexDirection: "row",
    borderBottomColor: "#BDBDBD",
    alignItems: "center",
    height: 24,
    fontSize: 12,
    fontStyle: "bold",
  },
  description: {
    width: "81%",
    textAlign: "right",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingRight: 12,
  },
  total: {
    width: "18%",
    textAlign: "right",
    fontWeight: "bold",
  },
});
const footerStyle = StyleSheet.create({
  base: {
    marginTop: "auto",
    backgroundColor: "#414141",
    color: "white",
    padding: 20,
  },
  logoImg: {
    width: 100,
    height: 30,
  },
});
const commentStyle = StyleSheet.create({
  base: {
    marginTop: 30,
  },
  title: {
    fontSize: "14px",
    marginBottom: 6,
  },
  box: {
    border: "1px solid #BDBDBD",
    padding: 5,
  },
});
